import { loading } from 'State/actions';
import { FileDownloadTypes } from 'Common/Constants/Enumeration/CommonEnum';
import * as types from './types';
import _ from 'lodash';

import { createToast, toastType } from '../../../common/ToastHelper';

export const getHistoryByItemReportAction = data => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch(loadingReportByItemAction(true));
    MPWWebApi.postGenericInsertUpdate('reports/historybyitem', data)
      .then(response => {
        dispatch({
          type: types.GET_HISTORYBYITEM_REPORT,
          payload: response,
        });
        dispatch(loadingReportByItemAction(false));
        if (!response.data.Data) {
          createToast(toastType.info, 'Results', 'No data found!', true);
        }
      })
      .catch(error => {
        dispatch({
          type: types.GET_HISTORYBYITEM_REPORT_ERROR,
          payload: error.response,
        });
        dispatch(loadingReportByItemAction(false));
        if (
          error.response.data &&
          error.response.data.Errors &&
          error.response.data.Errors[0].Title === null
        ) {
          createToast(toastType.error, 'Error', 'Unable to view report', true);
        } else {
          createToast(
            toastType.error,
            error.response.data.Errors[0].Title,
            error.response.data.Errors[0].Message,
            true
          );
        }
      });
  };
};

export const getHistoryByItemReportExcel = data => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loadingReportByItemAction(true));
      const dataPresent = await MPWWebApi.postDownloadFile(
        'reports/historybyitem',
        'HistoryByItemReport',
        data,
        FileDownloadTypes.ExcelOpenXML
      );
      if (!dataPresent) {
        createToast(toastType.info, 'Results', 'No data found!', true);
      }
    } catch (ex) {
      dispatch({
        type: types.GET_HISTORYBYITEM_REPORT_ERROR,
        payload: ex.response.data.Errors,
      });
    } finally {
      dispatch(loading(types.HISTORYBYITEM_REPORT_LOAD), false);
    }
  };
};

export const loadingReportByItemAction = status => {
  return {
    type: types.HISTORYBYITEM_REPORT_LOAD,
    payload: status,
  };
};

export const clearReportDataAction = () => {
  return {
    type: types.CLEAR_REPORT_DATA,
  };
};

export const getHistoryByStudentReportAction = data => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch(loadingReportByItemAction(true));
    MPWWebApi.postGenericInsertUpdate('reports/historybystudent', data)
      .then(response => {
        dispatch({
          type: types.GET_HISTORYBYSTUDENT_REPORT,
          payload: response,
        });
        dispatch(loadingReportByItemAction(false));
        if (!response.data.Data) {
          createToast(toastType.info, 'Results', 'No data found!', true);
        }
      })
      .catch(error => {
        dispatch({
          type: types.GET_HISTORYBYSTUDENT_REPORT_ERROR,
          payload: error.response,
        });
        dispatch(loadingReportByItemAction(false));
        if (
          error.response.data &&
          error.response.data.Errors &&
          error.response.data.Errors[0].Title === null
        ) {
          createToast(toastType.error, 'Error', 'Unable to view report', true);
        } else {
          createToast(
            toastType.error,
            error.response.data.Errors[0].Title,
            error.response.data.Errors[0].Message,
            true
          );
        }
      });
  };
};

export const getHistoryByStudentReportExcel = data => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loadingReportByItemAction(true));
      const dataPresent = await MPWWebApi.postDownloadFile(
        'reports/historybystudent',
        'HistoryByStudentReport',
        data,
        FileDownloadTypes.ExcelOpenXML
      );
      if (!dataPresent) {
        createToast(toastType.info, 'Results', 'No data found!', true);
      }
    } catch (ex) {
      dispatch({
        type: types.GET_HISTORYBYSTUDENT_REPORT_ERROR,
        payload: ex.response.data.Errors,
      });
    } finally {
      dispatch(loading(types.HISTORYBYITEM_REPORT_LOAD), false);
    }
  };
};

export const getUsersAction = () => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch(loadingFieldsAction(true));
    MPWWebApi.getGeneric('Usermaster/TransactionedUsers')
      .then(response => {
        dispatch({
          type: types.GET_HISTORYBYSTUDENT_USER,
          payload: response,
        });
        dispatch(loadingFieldsAction(false));
      })
      .catch(error => {
        dispatch({
          type: types.GET_HISTORYBYSTUDENT_USER_ERROR,
          payload: error.response,
        });
        dispatch(loadingFieldsAction(false));
      });
  };
};

export const loadingFieldsAction = status => {
  return {
    type: types.USER_LOAD,
    payload: status,
  };
};

export const getHistoryByDateReportAction = data => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch(loadingReportByItemAction(true));
    MPWWebApi.postGenericInsertUpdate('reports/historybydate', data)
      .then(response => {
        dispatch({
          type: types.GET_HISTORYBYDATE_REPORT,
          payload: response,
        });
        dispatch(loadingReportByItemAction(false));
        if (!response.data.Data) {
          createToast(toastType.info, 'Results', 'No data found!', true);
        }
      })
      .catch(error => {
        dispatch({
          type: types.GET_HISTORYBYDATE_REPORT_ERROR,
          payload: error.response ? error.response : error,
        });
        dispatch(loadingReportByItemAction(false));
        const warning = _.get(error, 'response.data.Data', null);
        if (warning) {
          createToast(toastType.info, 'Results', warning.Message, true);
        } else if (
          error.response &&
          error.response.data &&
          error.response.data.Errors &&
          error.response.data.Errors[0].Title === null
        ) {
          createToast(toastType.error, 'Error', 'Unable to view report', true);
        } else if (error.response) {
          createToast(
            toastType.error,
            error.response.data.Errors[0].Title,
            error.response.data.Errors[0].Message,
            true
          );
        }
      });
  };
};

export const getHistoryByDateReportExcel = data => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loadingReportByItemAction(true));
      const dataPresent = await MPWWebApi.postDownloadFile(
        'reports/historybydate',
        'HistoryByDateReport',
        data,
        FileDownloadTypes.ExcelOpenXML
      );
      if (!dataPresent) {
        createToast(toastType.info, 'Results', 'No data found!', true);
      }
    } catch (ex) {
      dispatch({
        type: types.GET_HISTORYBYITEM_REPORT_ERROR,
        payload: ex.response.data.Errors,
      });
    } finally {
      dispatch(loading(types.HISTORYBYITEM_REPORT_LOAD), false);
    }
  };
};



// WEBPACK FOOTER //
// ./src/pages/transactionhistory/state/actions.js